package audio

import com.github.chosamuel.tonejs.core.Tone
import jsObject
import toFreq

val oscA = js("""
        new Tone.PolySynth(Tone.Synth, {
            oscillator : {
                type : "sawtooth"
            }
        })
         """ ) as Tone.PolySynth

val oscB = js("""
        new Tone.PolySynth(Tone.Synth, {
            oscillator : {
                type : "square"
            }
        })
         """ ) as Tone.PolySynth

val oscillators = listOf(oscA,oscB)

val twinkle = js("""
        new Tone.PolySynth(Tone.Synth, {
            oscillator : {
                type : "sawtooth"
            }
        })
         """ ) as Tone.PolySynth


val lowPass = Tone.Filter(600.0,"lowpass")

var countLoopA = 0
var countLoopB = 0
var whichLoop = 0
val env = Tone.FrequencyEnvelope(jsObject {
    attack = 0.005
    decay = 0.95
    sustain = 0.0
    release = 15.0
    baseFrequency = 60
    octaves = 3
})

val twNotes = listOf("f5","g5", "g#5","a#5","c6","c#6","d#6","f6")

fun triggerTwinkle(){
    val note = twNotes.random()
    twinkle.triggerAttackRelease(note,"16n")
    env.triggerAttack()
}

fun setupAudio(){
    js("Tone.Transport.bpm.value = 64")
    twinkle.set(jsObject{
        envelope = jsObject{
            attack = 0.0
            decay = 1.55
            sustain = 0.5
            release = 15.0
        }
        polyphony = 1
    })
    val twinkleLowPass = Tone.Filter(120.0,"lowpass")

    env.connect(twinkleLowPass.frequency)
    val delay = Tone.FeedbackDelay(jsObject {
        delayTime = js("Tone.Time('16n').toSeconds() * 2")
        feedback = 0.4
        wet = 0.5
    })
    val reverb = Tone.Reverb(4)
    reverb.preDelay = 0.025
    val bgGain = Tone.Gain(0.20)
    val twGain = Tone.Gain(2.0)

    oscillators.forEach{
        it.set(jsObject { polyphony = 1 })
        it.connect(lowPass)
    }
    twinkle.connect(twinkleLowPass)
    lowPass.connect(bgGain)
    bgGain.connect(delay)
    twinkleLowPass.connect(twGain)
    twGain.connect(delay)
    delay.connect(reverb)
    reverb.toDestination()
}


fun loopA(){
    val notes = listOf(41,51,44,60)
    val now = Tone.now()
    notes.forEachIndexed { i, note ->
        oscillators.forEachIndexed{ j, it ->
            it.triggerAttackRelease(
                (note + j * 7).toFreq(),
                "16n",
                now + i * js("Tone.Time('16n').toSeconds() * 3") as Double
            )
            it.triggerAttackRelease(
                (56 + j * 7).toFreq(),
                "16n",
                now
                     + i * js("Tone.Time('16n').toSeconds() * 3") as Double
                     + js("Tone.Time('16n').toSeconds()") as Double
            )
        }
    }
    countLoopA ++
    if(countLoopA == 4){
        countLoopA = 0
        whichLoop = (whichLoop + 1) % 2
    }
}

fun loopB(){
    val notes = listOf(37,58,41,63)
    val now = Tone.now()
    notes.forEachIndexed { i, note ->
        oscillators.forEachIndexed{ j, it ->
            it.triggerAttackRelease(
                (note + j * 7).toFreq(),
                "16n",
                now + i * js("Tone.Time('16n').toSeconds() * 3") as Double
            )
            it.triggerAttackRelease(
                (53 + j * 7).toFreq(),
                "16n",
                now
                        + i * js("Tone.Time('16n').toSeconds() * 3") as Double
                        + js("Tone.Time('16n').toSeconds()") as Double
            )
        }
    }
    countLoopB ++
    if(countLoopB == 4){
        countLoopB = 0
        whichLoop = (whichLoop + 1) % 2
    }
}